import Storage from '../Storage.js';

Storage.setConfig("lists", {
  config: {
    method: "lists/",
    title: "Реестры",
    objectName: "Реестр"
  },
  properties: {
    id: {
      default: false,
      type: "text",
      title: "#",
      preset: true,
      width: "20px"
    },
    create_time: {
      default: "",
      type: "text",
      title: "Создан",
      preset: true,
      width: false
    },
    update_time: {
      default: "",
      type: "text",
      title: "Обновлен",
      preset: true,
      width: false
    },
    name: {
      default: "",
      type: "text",
      title: "Имя",
      preset: false,
      width: "auto"
    },
    mailings: {
      default: [],
      type: "multi",
      request: "mailings/",
      minSearch: 2,
      objectPageKey: "mailings",
      title: "Отправления",
      preset: false,
      width: false
    }
  }
});



// WEBPACK FOOTER //
// ./src/config/lists.js